import { NgModule } from '@angular/core';

import { epicObs } from '../../../store';

import { mainEpics } from './main/main.epic';
import { CmpsCoachingWpMainModule } from './main/main.module';

@NgModule({
    exports: [CmpsCoachingWpMainModule],
    imports: [CmpsCoachingWpMainModule],
})
export class CmpsCoachingWinningPercentageModule {
    constructor() {
        mainEpics.forEach((e) => epicObs.next(e));
    }
}
